import React from 'react';
import ReactDOM from 'react-dom/client';
import './static/css/index.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import InventoryPage from './pages/InventoryPage';
import CartProvider from './components/cart/cartProvider';
import CartPage from './pages/CartPage';
import Payment from './pages/SubscriptionPage';
import PaymentConfirmation from './pages/PaymentConfirmation';
import TermsAndAgreement from './pages/TAA';
 
const rootElement = document.getElementById('root');

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <CartProvider>
      <Router>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/inventory/" element={<InventoryPage/>}/>
          <Route path='/cart/' element={<CartPage/>}/>
          <Route path='/subscription/' element={<Payment/>}/>
          <Route path='/payment_success/' element={<PaymentConfirmation/>}/>
          <Route path='/terms_and_agreement/'element={<TermsAndAgreement/>}/>
        </Routes>
      </Router>
    </CartProvider>
  </React.StrictMode>
);